export const ROUTE_SEARCH = '/search';
export const ROUTE_SEARCH_ALTERNATE = '/courses';
export const ROUTE_TO_STATE_MAPPER = {
  refinementList: { categories: 'search.category.label' },
  menu: { type: 'search.type.value', language: 'search.language.value' },
};
export const STATE_TO_ROUTE_MAPPER = {
  refinementList: { 'search.category.label': 'categories' },
  menu: { 'search.type.value': 'type', 'search.language.value': 'language' },
};
